<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="login_titleBox">
          <!-- <div class="login_logo hidden-sm-and-down"></div> -->
          <div class="text-center login_title">
            <img src="../../assets/images/login_logo.png" />
            《{{$store.state.Name}}》{{titlea}} —
            <span class="highorange">{{title}}</span>
          </div>
        </div>
        <div class="login_maxBox">
          <div class="container login_box">
            <el-tabs v-model="activeName" @tab-click="handleClick" class="loginList">
              <el-tab-pane label="用户名登录" name="first" class="ten">
                <el-form ref="form" :model="form" label-width="100px" class="twenfive">
                  <div v-if="status!=1">
                  <el-form-item label="用户名:">
                    <el-col>
                      <el-input v-model="form.user" placeholder="请输入用户名" @input="oninput()"></el-input>
                      <div class="msg_error" v-show="userhid">{{userhid}}</div>
                      <div style="display: none;" class="msg_error">请输入用户名</div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="密码:">
                    <el-col>
                      <el-input v-model="form.pass" placeholder="请输入密码" show-password @blur="DetectInput($event, 'pws')" ></el-input>
                    </el-col>
                    <div class="msg_error" v-show="passhid">{{passhid}}</div>
                    <div class="clearfix"></div>
                  <div class="five five msg_error" style="zoom: normal" v-if="pwdErr">
                    <span>您的密码不符合相关要求，请<router-link to="/ChangePassword" style="color:#428bca;">点击此处</router-link>修改密码。</span>
                  </div>
                  </el-form-item>
                  <el-form-item label="验证码:">
                    <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcode"
                        placeholder="请输入验证码"
                        @keyup.enter.native="Login(1)"
                      ></el-input>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
                      <span style="cursor: pointer;">
                        <div
                          style="height: 40px;width: 110px;font-size: 22px;padding: 5px;"
                          @click="initVeri()"
                          :style="'background-image:url('+codeImg+')'"
                          v-html="Picture"
                        ></div>
                      </span>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" style="width: 100%;" v-show="yzhid">{{yzhid}}</div>
                  </el-form-item>
                  <el-form-item label class="loginbtn" v-if="!isLoginCode">
                    <el-button type="primary" @click="Login(1)">登录</el-button>
                  </el-form-item>
                  <el-form-item label class="loginbtn" v-else>
                    <el-button type="primary" @click="Login(1,1)">登录</el-button>
                  </el-form-item>
                </div>
                  <template v-if="status==1 && isLoginCode">
                <div class="twenfive" style="margin-top:0px;">
                <div class="highgreen">
                  系统已经发送验证码到{{mobelEm}}，若未收到验证码，请到邮件垃圾箱中查找一下。
                </div>
              </div>
                <el-form-item label="邮箱验证码:" :rules="[{ required: true}]" style="margin-top:15px;">
                <el-col :md="14" :lg="14" :xl="14">
                  <el-input
                    v-model="form.yzcodes"
                    placeholder="请输入邮箱验证码"
                  ></el-input>
                </el-col>
               <div class="clearfix"></div>
                  <div class="msg_error" v-html="yzcodesTiShi"></div>
              </el-form-item>
               <el-form-item label="">
                  <el-button style="width: 48%;" type="primary" @click="Login(1,2)"
                    >确认</el-button
                  >
                  <el-button
                    style="width: 48%"
                    class="ml1"
                    @click="$router.push('/')"
                    >取消</el-button
                  >
                </el-form-item>
                  </template>
                  <el-form-item label>
                    <div class="leftfloat login_pwd" style=" margin-left: 3px;">
                      <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer;"
                      >找回密码</a>
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane label="邮箱登录" name="second" class="ten">
                <el-form ref="form" :model="form" label-width="100px" class="twenfive">
                  <div v-if="status!=1">
                  <el-form-item label="邮箱:">
                    <el-col>
                      <el-input v-model="form.user" placeholder="请输入邮箱" @input="oninput"></el-input>
                      <div class="msg_error" v-show="userhid">{{userhid}}</div>
                      <div style="display: none;" class="msg_error">请输入邮箱</div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="密码:">
                    <el-col>
                      <el-input v-model="form.pass" placeholder="请输入密码" show-password @blur="DetectInput($event, 'pws')" ></el-input>
                    </el-col>
                    <div class="msg_error" v-show="passhid">{{passhid}}</div>
                    <div class="clearfix"></div>
                    
                  <div class="five five msg_error" style="zoom: normal" v-if="pwdErr">
                    <span>您的密码不符合相关要求，请<router-link to="/ChangePassword" style="color:#428bca;">点击此处</router-link>修改密码。</span>
                  </div>
                  </el-form-item>
                  <el-form-item label="验证码:">
                    <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcode"
                        placeholder="请输入验证码"
                        @keyup.enter.native="Login(2)"
                      ></el-input>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
                      <span style="cursor: pointer;">
                        <div
                          style="height: 40px;width: 110px;font-size: 22px;padding: 5px;"
                          @click="initVeri()"
                          :style="'background-image:url('+codeImg+')'"
                          v-html="Picture"
                        ></div>
                      </span>
                    </el-col>
                    <div class="msg_error" style="width: 100%;" v-show="yzhid">{{yzhid}}</div>
                  </el-form-item>
                  
                  <el-form-item label class="loginbtn" v-if="!isLoginCode">
                    <el-button type="primary" @click="Login(2)">登录</el-button>
                  </el-form-item>
                  <el-form-item label class="loginbtn" v-else>
                    <el-button type="primary" @click="Login(2,1)">登录</el-button>
                  </el-form-item>
                  </div>
                  <template v-if="status==1 && isLoginCode">
                <div class="twenfive" style="margin-top:0px;">
                <div class="highgreen">
                  系统已经发送验证码到{{mobelEm}}，若未收到验证码，请到邮件垃圾箱中查找一下。
                </div>
              </div>
                <el-form-item label="邮箱验证码:" :rules="[{ required: true}]" style="margin-top:15px;">
                <el-col :md="14" :lg="14" :xl="14">
                  <el-input
                    v-model="form.yzcodes"
                    placeholder="请输入邮箱验证码"
                  ></el-input>
                </el-col>
               <div class="clearfix"></div>
                  <div class="msg_error" v-html="yzcodesTiShi"></div>
              </el-form-item>
               <el-form-item label="">
                  <el-button style="width: 48%;" type="primary" @click="Login(2,2)"
                    >确认</el-button
                  >
                  <el-button
                    style="width: 48%"
                    class="ml1"
                    @click="$router.push('/')"
                    >取消</el-button
                  >
                </el-form-item>
                  </template>
                  <el-form-item label>
                    <div class="leftfloat" style=" margin-left: 3px;">
                      <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer;"
                      >找回密码</a>
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane label="手机登录" name="third" class="ten" v-if="isphone">
                <el-form ref="form" :model="form" label-width="100px" class="twenfive">
                  <div v-if="status!=1">
                  <el-form-item label="手机:">
                    <el-col>
                      <el-input v-model="form.user" placeholder="请输入手机" @input="oninput"></el-input>
                      <div class="msg_error" v-show="userhid">{{userhid}}</div>
                      <div style="display: none;" class="msg_error">请输入手机</div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="密码:">
                    <el-col>
                      <el-input v-model="form.pass" placeholder="请输入密码" show-password @blur="DetectInput($event, 'pws')"></el-input>
                    </el-col>
                    <div class="msg_error" v-show="passhid">{{passhid}}</div>
                    <div class="clearfix"></div>
                  <div class="five five msg_error" style="zoom: normal" v-if="pwdErr">
                    <span> 您的密码不符合相关要求，请<router-link to="/ChangePassword" style="color:#428bca;">点击此处</router-link>修改密码。</span>
                  </div>
                  </el-form-item>
                  <el-form-item label="验证码:">
                    <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcode"
                        placeholder="请输入验证码"
                        @keyup.enter.native="Login(3)"
                      ></el-input>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
                      <span style="cursor: pointer;">
                        <div
                          style="height: 40px;width: 110px;font-size: 22px;padding: 5px;"
                          @click="initVeri()"
                          :style="'background-image:url('+codeImg+')'"
                          v-html="Picture"
                        ></div>
                      </span>
                    </el-col>
                    <div class="msg_error" style="width: 100%;" v-show="yzhid">{{yzhid}}</div>
                  </el-form-item>
                  <el-form-item label class="loginbtn" v-if="!isLoginCode">
                    <el-button type="primary" @click="Login(3)">登录</el-button>
                  </el-form-item>
                  <el-form-item label class="loginbtn" v-else>
                    <el-button type="primary" @click="Login(3,1)">登录</el-button>
                  </el-form-item>
                  </div>
                  <template v-if="status==1 && isLoginCode">
                <div class="twenfive" style="margin-top:0px;">
                <div class="highgreen">
                  系统已经发送验证码到{{mobelEm}}，若未收到验证码，请到邮件垃圾箱中查找一下。
                </div>
              </div>
                <el-form-item label="邮箱验证码:" :rules="[{ required: true}]" style="margin-top:15px;">
                <el-col :md="14" :lg="14" :xl="14">
                  <el-input
                    v-model="form.yzcodes"
                    placeholder="请输入邮箱验证码"
                  ></el-input>
                </el-col>
               <div class="clearfix"></div>
                  <div class="msg_error" v-html="yzcodesTiShi"></div>
              </el-form-item>
               <el-form-item label="">
                  <el-button style="width: 48%;" type="primary" @click="Login(3,2)"
                    >确认</el-button
                  >
                  <el-button
                    style="width: 48%"
                    class="ml1"
                    @click="$router.push('/')"
                    >取消</el-button
                  >
                </el-form-item>
                  </template>
                  <el-form-item label>
                    <div class="leftfloat" style=" margin-left: 3px;">
                      <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer;"
                      >找回密码</a>
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>
            </el-tabs>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                没有账号?
                <a href="javascript:void(0)" @click="$router.push('/regist')">立即注册</a>
              </p>
              <p class="text-center">
                使用其他方式登录&nbsp;&nbsp;
                <a href="javascript:void(0)" @click="$router.push('/')">返回首页</a>
              </p>
               <p class="text-center" v-if="isweixin || IsQQLogin">已经有<span v-if="IsQQLogin">QQ，</span> <span v-if="isweixin">微信</span>账号，可直接登录，不用重复注册。</p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <el-button v-if="isweixin" type="text" @click="wxshow()" class="weixin">
                  <img src="../../assets/images/add_wx1.png" />
                </el-button>
                <el-dialog
                  :visible.sync="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">长按识别二维码注册并登录</p>
                    <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>
                    <div>
                      <img :src=" src " width="150" height="150" style />
                    </div>
                  </div>
                </el-dialog>
                <a style="cursor: pointer;" @click="useqqlogin" class="qq_login" v-if="IsQQLogin">
                  <img src="../../assets/images/add_qq1.png" />
                </a>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
                  :visible.sync="pwdFalseShow"
                  width="27%"
                  class="errDia"
                  :before-close="handleClose"
                  title="提示"
                >
                  <div style=" text-align: center;">
                    <p>您的密码不符合相关要求，请<router-link to="/ChangePassword" style="color:red;">点击此处</router-link>修改密码。</p>
                    
                  </div>
                </el-dialog>
    <MasterButtom></MasterButtom>
  </div>
</template>

<script>
var timeStop;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
import Login_WeiXin from "../../components/Login/Login_WeiXin";
import MasterButtom from "../../components/MasterButtom";
import axios from "../../assets/config/axios.config";
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); //十六位十六进制数作为密钥偏移量
export default {
  name: "login",
  data() {
    return {
      dialogVisible: false,
      loading: true,
      showWx: false,
      userhid: false,
      passhid: false,
      yzhid: false,
      isweixin: true,
      activeName: "first",
      isphone: false,
      ismobe: false,
      pwdFalseShow:false,
      pwdTiShi:"",
      pwdErr:false,
      userTishi:"",
      src: "",
      carousel: "",
      Code: "",
      timeStop: "",
      form: {
        name: "",
        type: "",
        pass: "",
        user: "",
        yzcode: "",
        yzcodes:""
      },
      checked: "",
      title: "",
      titlea: "",
      num: 1,
      roleName: "",
      Picture: "",
      codeImg: require("../../assets/images/timg.jpg"),
      GUID: "",
      wx: "",
      tab: 1,
      status:0,
      isLoginCode:false,
      mobelEm:"",
      yzcodesTiShi:""
    };
  },
  components: {
    Login_WeiXin,
    MasterButtom,
  },
  deactivated() {
    window.clearInterval(timeStop);
  },
  created() {
      
    
  },
  
  deactivated() {
    this.form = {
      name: "",
      type: "",
      pass: "",
      user: "",
      yzcode: "",
      yzcodes:""
    };
  },
  async mounted() {
    this.initVeri();
    if (this.$route.query.Guid) {
      let data = {
        guid: this.$route.query.Guid,
      };
      let res = await this.$store.dispatch("_getMMDL", data);
      if (res.data.IsSuccess) {
        if(!res.data.Data.IsGo){
          this.pwdFalseShow = true
          return;
        }
        localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
        window.location.href = res.data.Data.URL;
      } else {
        this.$message({
          showClose: true,
          message: res.data.Message,
          type: "err",
        });
        setTimeout(() => window.close(), 1000);
      }
    }else{
      if(window.localStorage.getItem("userInfo")){
        window.location.href = '/'
      }else{
        window.addEventListener("setItem", () => {
      let carousel = JSON.parse(sessionStorage.getItem("eqcode"));
      this.loading = false;
      this.$parent.loading = false;
      this.src = carousel.src;
      this.Code = carousel.Code;
    });
      }
    }
    if (this.$route.query.Login) {
      this.num = this.$route.query.Login;
    } else {
      if (sessionStorage.getItem("Login")) {
        this.num = sessionStorage.getItem("Login");
      } else {
        this.num = 1;
      }
    }

    
      let params = [
        1000,
        1001,
        4530,
        6018,
        6019,
        230,
        6055,
        5000,
        5010,
        99,
        96,
        11,
        2960,
        6021,
        6022
      ];
      this.$store.dispatch("_getSet", params).then((res) => {
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
        let SetItem = res.data.Data;
        SetItem.map((item) => {
          if (item.SetItemID == 11) {
            if (item.Item_Value == "是") {
              this.isphone = true;
            } else {
              this.isphone = false;
            }
          }
          if (item.SetItemID == 2960) {
            if (item.Item_Value == "是") {
              this.isweixin = true;
            } else {
              this.isweixin = false;
            }
          }
          if (item.SetItemID == 6022) {
          if (item.Item_Value == "是") {
            this.isLoginCode = true;
          } else {
            this.isLoginCode = false;
          }
        }
        });
      });
    

    if (localStorage.getItem("Logintype") == "email") {
      this.tab = 2;
      this.activeName = "second";
    } else if (localStorage.getItem("Logintype") == "phone") {
      this.tab = 3;
      this.activeName = "third";
    }
    if (this.num == "1") {
      this.title = "作者登录";
      this.titlea = "在线投稿系统";
      this.roleName = "Authors";
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem("user_Authors_user"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Authors_user")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Authors_user")).pass
          );
        }
      } else if (this.tab == 2) {
        if (JSON.parse(localStorage.getItem("user_Authors_email"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Authors_email")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Authors_email")).pass
          );
        }
      } else {
        if (JSON.parse(localStorage.getItem("user_Authors_phone"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Authors_phone")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Authors_phone")).pass
          );
        }
      }
    } else if (this.num == "3") {
      this.title = "专家登录";
      this.titlea = "专家审稿系统";
      this.roleName = "Experts";
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem("user_Experts_user"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Experts_user")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Experts_user")).pass
          );
        }
      } else if (this.tab == 2) {
        this.checked = true;
        if (JSON.parse(localStorage.getItem("user_Experts_email"))) {
          this.form.user = JSON.parse(
            localStorage.getItem("user_Experts_email")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Experts_email")).pass
          );
        }
      } else {
        if (JSON.parse(localStorage.getItem("user_Experts_phone"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Experts_phone")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Experts_phone")).pass
          );
        }
      }
    } else if (this.num == "2") {
      this.title = "编辑登录";
      this.titlea = "编辑办公系统";
      this.roleName = "Editors";
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem("user_Editors_user"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Editors_user")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Editors_user")).pass
          );
        }
      } else if (this.tab == 2) {
        this.checked = true;
        if (JSON.parse(localStorage.getItem("user_Editors_email"))) {
          this.form.user = JSON.parse(
            localStorage.getItem("user_Editors_email")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Editors_email")).pass
          );
        }
      } else {
        if (JSON.parse(localStorage.getItem("user_Editors_phone"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Editors_phone")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Editors_phone")).pass
          );
        }
      }
    }
  },

  methods: {
    oninput() {
      if (this.form.user == "") {
        this.form.pass = "";
      }
    },
    handleQrcodeCheck(type) {
       var urldomain =""
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch("_getWeiXinLogin", { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              if(!res.data.Data.IsGo){
                    this.pwdFalseShow = true
                    return;
                    }
              this.$message({ message: "登录成功", type: "success" });
              localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
              if (this.num == 1) {
                 urldomain = "/author/#/";
              }else if(this.num == 2){
                urldomain = "/editor/#/editor/Index";
              }else if(this.num == 3){
                urldomain = "/expert/#/examine-manuscripts";
              }
              
              window.location.href = urldomain;
              this.$emit("fuab", false);
            }
            
          });
      }, 2000);
    },
    //解密方法
    Decrypt(word) {
      let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      return decryptedStr.toString();
    },
    //加密方法
    Encrypt(word) {
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.ciphertext.toString().toUpperCase();
    },
    async wxshow() {
      this.dialogVisible = true;
      let carousel = await this.$store.dispatch("_getGetQrcode");
      if (carousel) {
        this.src = carousel.data.Url;
        this.Code = carousel.data.Code;
        this.loading = false;
        this.handleQrcodeCheck(this.type);
        this.$emit("func", this.src);
      }
    },
    getMsgFormSon(data) {
      this.loading = false;
      this.wx = data;
    },
    dialoga(data) {
      this.dialogVisible = false;
    },
    handleClick(tab, event) {
      this.tab = parseInt(tab.index) + 1;
      this.form = {
        name: "",
        type: "",
        pass: "",
        user: "",
        yzcode: "",
        yzcodes: "",
      };
      this.userhid = false;
      this.passhid = false;
      this.yzhid = false;
      this.status=0,
      this.mobelEm="",
      this.yzcodesTiShi=""
    },
     DetectInput(elem, type) {
	  	//焦点离开时候的事件
	  	
		if(type=='pws'){
	  		if(this.$Bai(elem.target.value)){
          this.passhid ="请输入密码！"
	  			return  
	  		}else if(this.$Space(elem.target.value)){
          this.passhid =""
           this.pwdErr = true
	  			return  
	  		}else if(this.$base(elem.target.value,"aff")){
          this.passhid =""
           this.pwdErr = true
	  			return  
	  		}else if(!this.$base(elem.target.value,"user")){
          this.passhid =""
           this.pwdErr = true
	  			return 
	  		}else{
          this.pwdErr = false
	  			this.pwdTiShi= "";
	  		}
	  	}
	
		if(type=='user'){
			if(this.$Bai(elem.target.value)){
				this.userTishi= "用户名不能为空";
			}else{
				this.userTishi= "";
			}
		}
	},

    async Login(num,at) {
      var Type = "";
      var UserKey = "";
      this.userhid = "";
      this.passhid = "";
      this.yzhid = "";
      if (num == 1) {
        Type = 1; //用户登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入用户名");
        }
        // if (!this.$base(this.form.user,"user")){
        //   return this.userhid="您的用户名格式不正确"
        // }
      } else if (num == 2) {
        Type = 2; //邮箱登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入邮箱");
        }
        if (!this.$base(this.form.user, "email")) {
          return (this.userhid = "您的邮箱格式不正确");
        }
      } else {
        Type = 3; //手机号登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入手机号");
        }
        if (!this.$base(this.form.user, "phone")) {
          return (this.userhid = "您的手机号格式不正确");
        }
      }
      if ((this.form.pass == "") | null) {
        this.pwdFalseShow = false
        return (this.passhid = "请输入密码");
      }else{
        
      }
      if (this.form.yzcode.length != 6) {
        return (this.yzhid = "请输入六位数的验证码");
      }
     if(this.$Space(this.form.pass)){
          this.pwdFalseShow = true
          return;
		    }else if (this.$base(this.form.pass,"aff")) {
          this.pwdFalseShow = true
          return;
		    }else if(!this.$base(this.form.pass,"user")){
          this.pwdFalseShow = true
          return;
		    }else{
          this.pwdFalseShow = false
        }
        
       if(at == 2){
         if(this.form.yzcodes =="" || !this.form.yzcodes){
          return this.yzcodesTiShi = "请输入邮箱或手机收到的六位数验证码"
         }  
       }
      //验证输入内容完毕  准备登录
      let pwm = md5(this.form.pass + "!@*Samson*@!");
      let pwaes = CryptoJS.AES.encrypt(this.form.pass, pwm).toString();
      let data = {
        Type,
        UserKey: this.form.user,
        pwm,
        pwaes,
        GUID: this.GUID,
        VCode: this.form.yzcode,
        roleName: this.roleName,
        Code:this.form.yzcodes
      };
      let res = await this.$store.dispatch("_postLogin", data);
      this.initVeri()
      if (res.data.IsSuccess) {
        if(at == 1){
            this.status = 1
            this.mobelEm = res.data.Message
            return
        }
          if(!res.data.Data.IsGo){
          this.pwdFalseShow = true
          return;
        }
        let user = {
          name: "",
          pass: "",
        };
        let loginData = {
          IsGo: res.data.Data.IsGo,
          GoPath: res.data.Data.GoPath,
        };
        
        localStorage.setItem("loginData", JSON.stringify(loginData));

        if (this.checked) {
          if (this.num == "1") {
            user.name = this.form.user;
            user.pass = this.Encrypt(this.form.pass);
            if (Type == 1) {
              localStorage.setItem("user_Authors_user", JSON.stringify(user));
            } else if (Type == 3) {
              localStorage.setItem("user_Authors_phone", JSON.stringify(user));
            } else {
              localStorage.setItem("user_Authors_email", JSON.stringify(user));
            }
          } else if (this.num == "3") {
            //专家登录
            user.name = this.form.user;
            user.pass = this.Encrypt(this.form.pass);
            if (Type == 1) {
              localStorage.setItem("user_Experts_user", JSON.stringify(user));
            } else if (Type == 3) {
              localStorage.setItem("user_Experts_phone", JSON.stringify(user));
            } else {
              localStorage.setItem("user_Experts_email", JSON.stringify(user));
            }
          } else if (this.num == "2") {
            user.name = this.form.user;
            user.pass = this.Encrypt(this.form.pass);
            if (Type == 1) {
              localStorage.setItem("user_Editors_user", JSON.stringify(user));
            } else if (Type == 3) {
              localStorage.setItem("user_Editors_phone", JSON.stringify(user));
            } else {
              localStorage.setItem("user_Editors_email", JSON.stringify(user));
            }
          }
        } else {
          if (this.num == "1") {
            if (Type == 1) {
              localStorage.removeItem("user_Authors_user");
            } else if (Type == 3) {
              localStorage.removeItem("user_Authors_phone");
            } else {
              localStorage.removeItem("user_Authors_email");
            }
          } else if (this.num == "3") {
            //专家登录
            if (Type == 1) {
              localStorage.removeItem("user_Experts_user");
            } else if (Type == 3) {
              localStorage.removeItem("user_Experts_phone");
            } else {
              localStorage.removeItem("user_Experts_email");
            }
          } else if (this.num == "2") {
            if (Type == 1) {
              localStorage.removeItem("user_Editors_user");
            } else if (Type == 3) {
              localStorage.removeItem("user_Editors_phone");
            } else {
              localStorage.removeItem("user_Editors_email");
            }
          }
        }
        if (Type == 1) {
          localStorage.setItem("Logintype", "user");
        } else if (Type == 3) {
          localStorage.setItem("Logintype", "phone");
        } else {
          localStorage.setItem("Logintype", "email");
        }

        this.$message({
          showClose: true,
          message: "登录成功，跳转中·······",
          type: "success",
        });

        setTimeout(() => {
          if (this.num == 1) {
            localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + "?firstLogin=true";
              return;
            }
            var urldomain = "/author/#/";
            window.location.href = urldomain;
            return;
          } else if (this.num == 2) {
            localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
            const hostname = document.location.hostname;
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + "?firstLogin=true";
              return;
            }
            var urldomain = "/editor/#/editor/Index";
            window.location.href = urldomain;
            return;
          } else if (this.num == 3) {
            localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
            const hostname = document.location.hostname;
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + "?firstLogin=true";
              return;
            }
            var urldomain = "/expert/#/examine-manuscripts";
            window.location.href = urldomain;
            return;
          }
        }, 1500);
      
        }else{
          this.$message({
          showClose: true,
          message: res.data.Message,
          type: "error",
        });
        }
        
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      var random_number = Math.floor(Math.random() * (100 + 1));
      let res = await this.$store.dispatch("_getVerificationcode", {
        GUID: "",
        random: random_number,
      });
      if (res.data.IsSuccess) {
        this.GUID = res.data.Data.GUID;
        this.Picture = "";
        for (var i = 0; i < res.data.Data.Picture.split("").length; i++) {
          this.Picture +=
            '<span style="color:' +
            this.randomColor() +
            '">' +
            res.data.Data.Picture.split("")[i] +
            "</span>";
        }
      } else {
        alert("网络错误");
      }
    },
    //点击QQ登录
    // tz() {
    // 	var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101866331&response_type=token&scope=all&redirect_uri=http:/2020test.notefirst.com/login_qq";
    // 	window.location.href = urldz;
    // },
    useqqlogin() {
      // this.$router.push("/login_qq")
      // let redirect = "http://2020test.notefirst.com"
      // this.Openkind ="QQ"
      // QC.Login.showPopup({//打开QQ授权登录界面，授权成功后会重定向
      // appId:"101871016",
      // redirectURI:"http://2020test.notefirst.com/#/login_qq",//登录成功后会自动跳往该地址
      // });
      var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id="+window.OpenId+"&response_type=token&scope=all&redirect_uri=http%3A%2F%2F"+window.callBackHtp+"%2F%23%2Flogin_qq";
      window.location.href = urldz;
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
    randomColor() {
      var col = "rgb(";
      for (var i = 0; i < 3; i++) {
        col += Math.floor(Math.random() * 256) + ",";
      }
      col = col.slice(0, -1);
      col += ")";
      return col;
    },
  },
};
</script>

<style scoped>
.eqcode {
  font-size: 16px;
}
.loginbtn .el-button--primary {
  width: 100% !important;
}
</style>
